import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Link from '@material-ui/core/Link';
import TamperTesterLogoDark from './tamper_tester_logo_dark.svg';

const useStyles = makeStyles({
	toolbar: {
		justifyContent: 'center',
	},
});

function TamperTesterHeader(props) {
	const classes = useStyles(props);
	const theme = useTheme();

	return (
		<AppBar
			position="static"
			color="inherit"
			style={{ background: theme.palette.grey[100] }}
			elevation={0}
		>
			<Toolbar variant="dense" className={classes.toolbar}>
				<Link href="/" style={{ lineHeight: 1 }}>
					<img src={TamperTesterLogoDark} alt="Tamper Tester" />
				</Link>
			</Toolbar>
		</AppBar>
	);
}

export default TamperTesterHeader;
